import { pipe } from 'fp-ts/function';
import { array, nonEmptyArray } from 'fp-ts';
import { keepPreviousData } from '@tanstack/react-query';
import { Account, AccountType, useRepositoryQuery } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';

const getCustomerOrCompanyFullName = ({ data }: Account) =>
    data.discriminator === AccountType.Company ? data.value.name : getFullName(data.value);

export const useGetAccountName = (accountId: string) =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        { accountIds: [accountId] },
        {
            placeholderData: keepPreviousData,
            enabled: !!accountId,
            select: ({ accounts }) =>
                accounts && array.isNonEmpty(accounts)
                    ? pipe(accounts, nonEmptyArray.head, (account) => getCustomerOrCompanyFullName(account))
                    : null,
        }
    );
